import * as Sentry from '@sentry/react'

import { IS_PRODUCTION } from 'config/constants'

const APP_LOG_LEVELS = {
  LOG: ['log', 'info', 'warn', 'error'],
  INFO: ['info', 'warn', 'error'],
  WARN: ['warn', 'error'],
  ERROR: ['error'],
}

export const initSentry = () => {
  if (process.env.REACT_APP_SENTRY_ENABLED === 'false') {
    return
  }

  // profilesSampleRate is relative to tracesSampleRate
  // ex. tracesSampleRate: 0.01, profilesSampleRate: 1.0, means (0.01)*(1.0)=1% of all transactions will be profiled
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    enabled: IS_PRODUCTION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: APP_LOG_LEVELS[process.env.REACT_APP_SENTRY_LOG_LEVEL || 'ERROR'],
      }),
      Sentry.browserApiErrorsIntegration(),
    ],
    environment: process.env.REACT_APP_KILLI_ENV,
    release: process.env.REACT_APP_RELEASE_VERSION,
    sampleRate: IS_PRODUCTION ? 0.05 : 1.0,
    tracesSampleRate: IS_PRODUCTION ? 0.01 : 1.0,
    profilesSampleRate: 1.0,
  })
}

export const setSentryUser = (userAlias) => {
  Sentry.setUser(userAlias ? { id: userAlias } : null)
}

export const setRegion = (region) => {
  Sentry.setTag('region', region)
}

export default {
  initSentry,
  setSentryUser,
  setRegion,
}
